import useSetChartExport from '@components/export/useSetChartExport';
import React from 'react';
import { useCompareData } from '../hooks/useCompareSeries';
import { getFilterNameFn } from '@components/dimension-panel-hz/drawer/utils';
import { COMPARE_TYPES } from '@store/trends/base/reducer';
import { DATA_TAGS } from '../hooks/useData';

function ExportCompareFilters() {
  const { data, compareFilters, totals } = useCompareData({ dataTag: DATA_TAGS.compare });
  return compareFilters.map( (filter, idx) => (
    <ExportTs data={data[idx]} totals={totals[idx]}  filter={filter} idx={idx} key={`${filter.name}-${idx}`} />
  ));
}

const getFilterName = getFilterNameFn(COMPARE_TYPES.trends);

function ExportTs({ totals, data, filter, idx }) {
  const widgetKey = `compare-series-${idx}`;

  useSetChartExport({
    pageKey: 'trends',
    sectionKey: 'compare-panel',
    widgetKey,
    widgetInfo: {
      title: `Timeseries for ${getFilterName(filter)}`,
    },
    data,
    totals,
  })

  return <React.Fragment  key={widgetKey} />;
}

export default ExportCompareFilters;
